class Slider {
  constructor(el) {
    if (!el) return;
    this.main = el;
    this.slider = this.main.querySelector(".c-slider");
    this.sliderItems = this.main.querySelectorAll(".c-slider-item");
    this.sliderItemsOne = [];
    this.sliderItemsTwo = [];

    this.sliderItemsLength = this.sliderItems.length;
    this.sliderTimeout = 5000;
    this.sliderCurrent = 0;

    this.sliderCalc = {
      item: 0,
      active: 0,
      total: 0,
      center: 0,
      totalInner: 0,
    };

    this.resizeTimeout = null;
    this.transitionTimeout = null;
    this.transitionTimeoutTransition = null;

    this.duplicateSliderItems();
    this.sliderResize();
    window.addEventListener("resize", this.sliderResize.bind(this));
  }

  sliderNext() {
    this.sliderCurrent++;
    if (this.sliderCurrent >= this.sliderItemsLength) {
      this.sliderCurrent = 0;
    }

    this.sliderGo();
  }

  sliderGo() {
    for (let i = 0; i < this.sliderItems.length; i++) {
      const el = this.sliderItems[i];
      if (i === this.sliderCurrent) {
        el.classList.add("is-active");
        this.sliderItemsOne[i].classList.add("is-active");
        this.sliderItemsTwo[i].classList.add("is-active");
      } else {
        el.classList.remove("is-active");
        this.sliderItemsOne[i].classList.remove("is-active");
        this.sliderItemsTwo[i].classList.remove("is-active");
      }

      this.main.style.transform = `translateX(${
        this.sliderCalc["center"] - this.sliderCalc["item"] * this.sliderCurrent
      }px)`;
    }

    if (this.sliderCurrent === this.sliderItemsLength - 1) {
      this.transitionTimeout = setTimeout(() => {
        this.main.classList.remove("has-transition");
        this.main.style.transform = `translateX(${
          this.sliderCalc["center"] + this.sliderCalc["active"]
        }px)`;
        this.transitionTimeout = null;
      }, 750);
      this.transitionTimeoutTransition = setTimeout(() => {
        this.main.classList.add("has-transition");
        this.transitionTimeoutTransition = null;
      }, 760);
    }
  }

  duplicateSliderItems() {
    this.sliderClone = this.slider.cloneNode(true);
    this.sliderClone2 = this.slider.cloneNode(true);
    this.sliderClone.classList.add("is-clone-next");
    this.sliderClone2.classList.add("is-clone-prev");
    this.main.appendChild(this.sliderClone);
    this.main.appendChild(this.sliderClone2);
    this.sliderItemsOne = this.sliderClone.querySelectorAll(".c-slider-item");
    this.sliderItemsTwo = this.sliderClone2.querySelectorAll(".c-slider-item");
  }

  sliderResize() {
    if (this.sliderInterval) {
      clearTimeout(this.sliderInterval);
    }
    if (this.transitionTimeout) {
      clearTimeout(this.transitionTimeout);
    }
    if (this.transitionTimeoutTransition) {
      clearTimeout(this.transitionTimeoutTransition);
    }
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }

    // cleanup
    this.main.classList.remove("has-transition");
    this.main.removeAttribute("style");
    this.sliderClone.removeAttribute("style");
    this.sliderClone2.removeAttribute("style");

    //
    this.main.style.height = `${
      this.sliderItems[this.sliderCurrent].offsetHeight
    }px`;
    const mainWidth = this.main.offsetWidth;
    const itemWidth = this.main.querySelector(
      ".c-slider-item:not(.is-active)"
    ).offsetWidth;
    const itemActiveWidth = this.main.querySelector(
      ".c-slider-item.is-active"
    ).offsetWidth;

    this.sliderCalc = {
      item: itemWidth,
      active: itemActiveWidth,
      total: mainWidth,
      center: (mainWidth - itemActiveWidth) / 2,
      totalInner: itemActiveWidth + itemWidth * (this.sliderItemsLength - 1),
    };
    this.main.style.transform = `translateX(${this.sliderCalc["center"]}px)`;
    this.sliderClone.style.left = `${this.sliderCalc["totalInner"]}px`;
    this.sliderClone2.style.left = `-${this.sliderCalc["totalInner"]}px`;
    this.resizeTimeout = setTimeout(() => {
      this.main.classList.add("has-transition");
      this.resizeTimeout = null;
    }, 10);

    this.sliderGo();

    this.sliderInterval = setInterval(() => {
      this.sliderNext();
    }, this.sliderTimeout);
  }
}

export default Slider;
